import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';
import { NotifyHelpers } from '@/ts/helpers/NotifyHelpers';

@Module({name: 'Tickets', namespaced: true})
export default class Tickets extends VuexModule {
    public tickets: any[] = [];
    public ticketInfo: any = [];
    public socketInitTicketIds: any = [];
    public addTicketProperties: any = [];
    public addTicketRecievers: any = [];
    public ticketAllStates: any[] = [];
    public ticketSuggestedWatchers: any[] = [];
    public ticketRoleAssignee: any[] = [];
    public projectAllBuildings: any = [];
    public ticketsConversation: any = [];
    public ticketInfoVisible: boolean = false;
    public ticketImagePreviewVisible: boolean = false;
    public ticketsStatusOption: string = 'all';
    public ticketCreateFormVisibility: boolean = false;
    public ticketAddFormVisibility: boolean = false;

    @Mutation
    public RESET_TICKETS_STORE_STATE() {
        this.tickets                    = [];
        this.ticketInfo                 = [];
        this.socketInitTicketIds        = [];
        this.addTicketProperties        = [];
        this.addTicketRecievers         = [];
        this.ticketAllStates            = [];
        this.ticketSuggestedWatchers    = [];
        this.ticketRoleAssignee         = [];
        this.projectAllBuildings        = [];
        this.ticketsConversation        = [];
        this.ticketInfoVisible          = false;
        this.ticketImagePreviewVisible  = false;
        this.ticketsStatusOption        = 'all';
        this.ticketCreateFormVisibility = false;
        this.ticketAddFormVisibility    = false;
    }

    get getAllTickets() {
        return this.tickets;
    }

    get getTicketAllStates() {
        return this.ticketAllStates;
    }

    get getTicketSuggestedWatchers() {
        return this.ticketSuggestedWatchers;
    }

    get getTicketRoleAssignee() {
        return this.ticketRoleAssignee;
    }

    get getTicketsConversation() {
        return this.ticketsConversation;
    }

    get getProjectAllBuildings() {
        return this.projectAllBuildings;
    }

    get getTicketsStatusOption() {
        return this.ticketsStatusOption;
    }

    get getTicketInfoVisible() {
        return this.ticketInfoVisible;
    }

    get getTicketImagePreviewVisible() {
        return this.ticketImagePreviewVisible;
    }

    get getTicketInfo() {
        return this.ticketInfo;
    }

    get getTicket() {
        return (ticketId: number) => {
            return this.tickets.find((ticket: any) => ticket.id === ticketId);
        };
    }

    get getTicketCreateFormVisibility(): boolean {
        return this.ticketCreateFormVisibility;
    }

    get getTicketAddFormVisibility(): boolean {
        return this.ticketAddFormVisibility;
    }

    get getAddTicketProperties() {
        return this.addTicketProperties;
    }

    get getAddTicketRecievers() {
        return this.addTicketRecievers;
    }

    get getSocketInitTicketIds() {
        return this.socketInitTicketIds;
    }

    @Action
    public FETCH_ALL_TICKETS(data: any) {
        axios.get(Endpoints.Admin.TicketSystem.TICKETS(data.type))
            .then((response: any) => {
                store.commit(Mutations.SET_ALL_TICKETS, response.data.data);
                store.commit(Mutations.SET_TICKETS_STATUS_OPTION, data.type);

                for (const ticket of response.data.data) {
                    if (store.getters['Socket/isSocketActive'] && data.vue && !store.getters['Tickets/getSocketInitTicketIds'].includes(ticket.id)) {
                        store.dispatch(Actions.INITIALIZE_TICKET_SOCKET, {vue: data.vue, ticketId: ticket.id});
                        store.commit(Mutations.ADD_SOCKET_INIT_TICKET_ID, ticket.id);
                    }
                }
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_TICKET_ROLE_ASSIGNEE(data: any) {
        axios.get(Endpoints.Admin.TicketsAttributes.TICKET_ROLE_ASSIGNEE(data.projectId, data.categoryId, data.all))
            .then((response: any) => {
                store.commit(Mutations.SET_TICKET_ROLE_ASSIGNEE, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_TICKET_ALL_STATES() {
        axios.get(Endpoints.Admin.TicketSystem.TICKET_ALL_STATES)
            .then((response: any) => {
                store.commit(Mutations.SET_TICKET_ALL_STATES, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public EDIT_CURRENT_TICKET(data: any) {
        const requestData = {
            id: data.id,
            priority: data.priority,
            watchers: data.watchers,
            assigne_id: data.assigne_id,
            state_id: data.state_id,
            category_id: data.category_id,
            type_id: data.type_id,
        };

        axios.put(Endpoints.Admin.TicketSystem.CURRENT_TICKET(data.id), requestData)
            .then(() => {
                store.commit(Mutations.SET_CURRENT_TICKET, []);
                store.commit(Mutations.SET_TICKET_INFO_VISIBILITY, false);
                store.dispatch(Actions.RESET_ACTIVE_TICKET_ROWS);
                store.dispatch(Actions.FETCH_ALL_TICKETS, { vue: null, type: store.getters['Tickets/getTicketsStatusOption'] });

                NotifyHelpers.notify('ticket_has_been_updated', 'positive');
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_TICKET_SUGGESTED_WATCHERS(data: any) {
        const requestData = {
            search: data.search,
            watchers: data.watchers,
        };

        axios.post(Endpoints.Admin.TicketSystem.TICKET_SUGGESTED_WATCHERS(data.projectId), requestData)
            .then((response: any) => {
                store.commit(Mutations.SET_TICKET_SUGGESTED_WATCHERS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public SEND_MESSAGE_TO_TICKET_USER(requestData: any) {
        axios.post(Endpoints.Admin.TicketSystem.SEND_MESSAGE_TO_TICKET_USER(requestData.ticketId), requestData)
            .then((response) => {
                if (!store.getters['Socket/isSocketActive'] && !store.getters['Socket/isTicketSocketInitialized']) {
                    store.commit(Mutations.PUSH_TO_TICKET_CONVERSATION, response.data);
                }
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public DELETE_TICKET_MESSAGE(data: any) {
        return axios.delete(Endpoints.Admin.TicketSystem.REMOVE_TICKET_MESSAGE(data.ticketId, data.messageId))
            .then((response) => {
                store.commit(Mutations.REMOVE_TICKET_CONVERSATION_MESSAGE, response.data);
                store.commit(Mutations.REMOVE_USER_TICKET_CONVERSATION_MESSAGE, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                    console.log(error.response.data);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_TICKET_CONVERSATION(ticketId: number) {
        axios.get(Endpoints.Admin.TicketSystem.FETCH_TICKET_CONVERSATION(ticketId))
            .then((response: any) => {
                store.commit(Mutations.SET_TICKET_CONVERSATION, { conversation: response.data, scroll: true });
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_CURRENT_TICKET(ticketId: number) {
        axios.get(Endpoints.Admin.TicketSystem.CURRENT_TICKET(ticketId))
            .then((response: any) => {
                store.commit(Mutations.SET_CURRENT_TICKET, response.data.data);
                store.commit(Mutations.MAKE_TICKET_RESPONDED, response.data.data);
                store.commit(Mutations.SET_TICKET_INFO_VISIBILITY, true);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_ADD_TICKET_PROPERTIES(projectId: number) {
        axios.get(Endpoints.Admin.TicketSystem.ADD_TICKET_PROPERTIES(projectId))
            .then((response: any) => {
                store.commit(Mutations.SET_ADD_TICKET_PROPERTIES, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_ADD_TICKET_RECIEVERS(propertyId: number) {
        axios.get(Endpoints.Admin.TicketSystem.ADD_TICKET_RECEIVERS(propertyId))
            .then((response: any) => {
                store.commit(Mutations.SET_ADD_TICKET_RECIEVERS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public ADMIN_ADD_TICKET(data: any) {
        return axios.post(Endpoints.Admin.TicketSystem.ADMIN_ADD_TICKET, data.requestData)
            .then((response) => {
                if (!data.mobile) {
                    store.commit(Mutations.APPEND_TICKET, response.data.data);
                    store.commit(Mutations.SET_TICKET_ADD_FORM_VISIBILITY, false);

                    NotifyHelpers.notify('ticket_has_been_added', 'positive');
                } else {
                    store.commit(Mutations.ADD_NEW_USER_TICKET, response.data.data);
                }

                if (store.getters['Socket/isSocketActive'] && store.getters['Socket/isTicketSocketInitialized']) {
                    store.dispatch(Actions.INITIALIZE_TICKET_SOCKET, {vue: data.vue, ticketId: response.data.data.id});
                    store.commit(Mutations.ADD_SOCKET_INIT_TICKET_ID, response.data.data.id);
                }
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public OPEN_TICKET_MODAL(ticketId: number) {
        store.dispatch(Actions.RESET_ACTIVE_TICKET_ROWS);
        store.dispatch(Actions.FETCH_CURRENT_TICKET, ticketId);
    }

    @Action
    public RESET_ACTIVE_TICKET_ROWS() {
        const rows = document.querySelectorAll('.ticketItem');
        rows.forEach( (row) => row.classList.remove('active'));
    }

    @Action
    public INITIALIZE_TICKET_SOCKET(data: any) {
        const ticketChannel = 'ticket.' + data.ticketId;
        data.vue.$echo.private(ticketChannel)
            .listen(('.ticket.updated'), (ticketPayload: any) => {
                store.commit(Mutations.EXECUTE_TICKET_UPDATE, ticketPayload);
            });
        store.commit(Mutations.TICKET_SOCKET_INITIALIZED);
    }

    @Mutation
    public MAKE_TICKET_RESPONDED(data: any) {
        const ticket = this.tickets.find((t: any) => t.id === data.id);

        if (ticket && !ticket.firstResponse) {
            ticket.firstResponse = data.firstResponse;
            ticket.firstResponder = data.firstResponder;
        }
    }

    @Mutation
    public EXECUTE_TICKET_UPDATE(data: any) {
        if (data.type === 'message') {
            store.commit(Mutations.PUSH_TO_TICKET_CONVERSATION, data.data);
        } else if (data.type === 'state') {
            store.commit(Mutations.UPDATE_TICKET_STATE, data.data);
        } else if (data.type === 'assignee') {
            store.commit(Mutations.UPDATE_TICKET_ASSIGNEE, data.data);
        } else if (data.type === 'priority') {
            store.commit(Mutations.SET_TICKET_PRIORITY, data.data);
        } else if (data.type === 'message_deleted') {
            store.commit(Mutations.REMOVE_TICKET_CONVERSATION_MESSAGE, data.data);
            store.commit(Mutations.REMOVE_USER_TICKET_CONVERSATION_MESSAGE, data.data);
        }
    }

    @Mutation
    public UPDATE_TICKET_ASSIGNEE(data: any) {
        if (this.ticketInfo && this.ticketInfo.id === data.ticketId) {
            this.ticketInfo.assigne_id = data.data.assigne_id;
            this.ticketInfo.assignee_name    = data.data.assignee_name;
        }

        const ticket = this.tickets.find((tk: any) => tk.id === data.ticketId);
        if (ticket) {
            ticket.assigne_id = data.data.assigne_id;
            ticket.assignee_name = data.data.assignee_name;
        }
    }

    @Mutation
    public SET_TICKET_PRIORITY(data: any) {
        if (this.ticketInfo && this.ticketInfo.id === data.ticketId) {
            this.ticketInfo.priority = data.data.priority;
        }

        const ticket = this.tickets.find((tk: any) => tk.id === data.ticketId);
        if (ticket) {
            ticket.priority = data.data.priority;
        }
    }

    @Mutation
    public UPDATE_TICKET_STATE(data: any) {
        if (this.ticketInfo && this.ticketInfo.id === data.ticketId) {
            this.ticketInfo.state_id = data.data.state_id;
            this.ticketInfo.state    = data.data.state;
        }

        const ticket = this.tickets.find((tk: any) => tk.id === data.ticketId);
        if (ticket) {
            ticket.state_id = data.data.state_id;
            ticket.state = data.data.state;
        }
    }

    @Mutation
    public ADD_SOCKET_INIT_TICKET_ID(id: number) {
        this.socketInitTicketIds.push(id);
    }

    @Mutation
    public SET_ALL_TICKETS(tickets: any) {
        this.tickets = tickets;
    }

    @Mutation
    public SET_TICKET_INFO_VISIBILITY(visibility: boolean) {
        this.ticketInfoVisible = visibility;
    }

    @Mutation
    public SET_TICKET_IMAGE_PREVIEW_VISIBILITY(visibility: boolean) {
        this.ticketImagePreviewVisible = visibility;
    }

    @Mutation
    public SET_CURRENT_TICKET(ticket: any) {
        this.ticketInfo = ticket;
    }

    @Mutation
    public SET_TICKETS_STATUS_OPTION(status: string) {
        this.ticketsStatusOption = status;
    }

    @Mutation
    public SET_ADD_TICKET_PROPERTIES(properties: number) {
        this.addTicketProperties = properties;
    }

    @Mutation
    public SET_ADD_TICKET_RECIEVERS(recievers: number) {
        this.addTicketRecievers = recievers;
    }

    @Mutation
    public SET_TICKET_ADD_FORM_VISIBILITY(visibility: boolean) {
        this.ticketAddFormVisibility = visibility;
    }

    @Mutation
    public APPEND_TICKET(ticket: any) {
        this.tickets.unshift(ticket);
    }

    @Mutation
    public SET_TICKETS_PROJECT_BUILDINGS(data: any) {
        this.projectAllBuildings = data;
    }

    @Mutation
    public SET_TICKET_SUGGESTED_WATCHERS(data: any) {
        this.ticketSuggestedWatchers = data;
    }

    @Mutation
    public SET_TICKET_ALL_STATES(data: any) {
        this.ticketAllStates = data;
    }

    @Mutation
    public SET_TICKET_ROLE_ASSIGNEE(data: any) {
        this.ticketRoleAssignee = data;
    }

    @Mutation
    public SET_TICKET_CONVERSATION(data: any) {
        this.ticketsConversation = data.conversation;

        if (data.scroll) {
            setTimeout(() => {
                const objDiv = document.getElementById('communication-msg-block-id');
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 500);
        }
    }

    @Mutation
    public PUSH_TO_TICKET_CONVERSATION(data: any) {
        if (typeof this.ticketsConversation.messages !== 'undefined') {
            if (this.ticketsConversation.id === data.conversation_id) {
                this.ticketsConversation.messages.push(data);
            }

            setTimeout(() => {
                const objDiv = document.getElementById('communication-msg-block-id');
                objDiv.scrollTop = objDiv.scrollHeight;
            }, 200);
        }
    }

    @Mutation
    public REMOVE_TICKET_CONVERSATION_MESSAGE(data: any) {
        if (typeof this.ticketsConversation.messages !== 'undefined') {
            if (this.ticketsConversation.id === data.conversation_id) {
                const message = this.ticketsConversation.messages.find((m: any) => m.id === data.id);

                if (message) {
                    this.ticketsConversation.messages = this.ticketsConversation.messages.filter((m: any) => m.id !== data.id);
                }
            }
        }
    }

    @Mutation
    public SET_TICKET_CREATE_FORM_VISIBILITY(visibility: boolean) {
        this.ticketCreateFormVisibility = visibility;
    }
}

